<template>

  <v-checkbox v-model="checked" :label="label"></v-checkbox>

</template>

<script>
  export default {
    name: 'ob-checkbox',

    props: [ 'value', 'label' ],

    computed: {
      checked: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
          this.$emit('change', value)
        }
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
